import { defineMessages } from '@/i18n'
import { DESIGN_TEXT_STUDIO_LIMIT } from '@/features/editor/lib/designElementDefaults'

/** Тексты студии редактора: шапка панели блока, миниатюры, таймлайн, диалоги. */
export const messages = defineMessages({
  ru: {
    a11yBack: 'Назад',
    a11yDelete: 'Удалить',
    a11yDeleteBlock: 'Удалить блок',
    openBlockPanel: 'Настройки экрана',
    closeBlockPanel: 'Закрыть настройки',
    hideAiPanel: 'Скрыть AI-панель',
    showAiPanel: 'Показать AI-панель',
    noRights: 'Нет прав',
    saving: 'Сохранение…',
    save: 'Сохранить',
    delete: 'Удалить',
    cancel: 'Отмена',
    loadFailedTitle: 'Ой, курс не открылся…',
    loadFailedDescription: 'Проверьте интернет и попробуйте ещё раз.',
    retry: 'Повторить',
    overflowWarnLabel: 'Текста много',
    overflowWarnHint:
      'Блок чуть длиннее экрана: на телефоне он уменьшится, и текст станет мельче. Рекомендуем сократить, чтобы читалось хорошо.',
    overflowLabel: 'Блок переполнен',
    overflowHint:
      'Блок переполнен: на телефоне текст станет слишком мелким. Сократите текст или уберите элемент — иначе курс не опубликовать.',
    deleteScreenUnknown: 'Удалить блок?',
    deleteScreen: (n: number) => `Удалить блок ${n}?`,
    deleteScreenDescription: (label: string) =>
      `Блок «${label}» будет удалён во всех языках курса без возможности восстановления.`,
    duplicateScreen: 'Скопировать блок',
    editNotice: 'Блок переписывает AI. Правка станет доступна, когда AI закончит.',
    editHeaderTitle: 'Блок переписывает AI',
    editChip: 'переписывается',
    editThumbTitle: 'Блок переписывает AI',
    translationNotice:
      'Идёт перевод курса. Блок временно недоступен для правки, пока перевод не закончится.',
    translationHeaderTitle: 'Идёт перевод — блок недоступен для правки',
    translationChip: 'идёт перевод',
    translationThumbTitle: 'Идёт перевод курса',
    reviewNotice: 'Курс на проверке. Правка станет доступна после решения.',
    reviewHeaderTitle: 'Курс на проверке — блок недоступен для правки',
    reviewChip: 'На проверке',
    reviewThumbTitle: 'На проверке',
    selectBlockOrLesson: 'Выберите блок или урок',
    courseSettings: 'Настройки курса',
    courseNotFound: 'Курс не найден',
    selectArticle: 'Выберите статью',
    reviewLockWithdraw:
      'Курс на проверке — редактирование вернётся после решения. Отозвать заявку можно в окне публикации.',
    reviewLock: 'Курс на проверке — редактирование вернётся после решения.',
    selectBlockForPreview: 'Выберите блок для превью',
    addLessonFirst: 'Сначала добавьте урок и блок внизу',
    addLesson: 'Добавить урок',
    collapseScreens: 'Свернуть экраны',
    expandScreens: 'Показать миниатюры экранов',
    untitled: 'Без названия',
    deleteLesson: (n: number) => `Удалить урок ${n}?`,
    deleteLessonButton: 'Удалить урок',
    deleteLessonDescription:
      'Урок и все его блоки будут удалены во всех языках курса без возможности восстановления.',
    lessonImage: 'Картинка урока',
    upload: 'Загрузить',
    tabInfo: 'Инфо',
    tabLook: 'Оформление',
    lessonNumber: (n: number) => `Урок ${n}`,
    lessonSettings: 'Настройки урока',
    translationTextLocked: 'Идёт перевод — текст временно недоступен для правки',
    lessonName: 'Название урока',
    shortDescription: 'Короткое описание',
    shortDescriptionPlaceholder: 'Одно предложение о том, что в этом уроке',
    noPattern: 'Без паттерна',
    blocksBackground: 'Фон блоков',
    lessonTheme: 'Тема урока',
    pattern: 'Узор',
    backgroundPattern: 'Паттерн фона',
    desktop: 'ПК',
    phone: 'Телефон',
    rotatePhone: 'Повернуть телефон',
    lookRefusedReview: 'Оформление не применено: курс на проверке',
    lookRefusedAi: 'Оформление не применено: сейчас AI переписывает блоки',
    lookPartial: 'Оформление применено не ко всем блокам — попробуйте ещё раз',
    saveBlockFailed: 'Не удалось сохранить блок',
    designTextTooLong: `Текст длиннее ${DESIGN_TEXT_STUDIO_LIMIT} знаков — сократите его, иначе блок не сохранится`,
    deleteBlockFailed: 'Не удалось удалить блок',
    videoUploadCancelledBlockKept: 'Загрузка ролика отменена, а блок удалить не удалось',
    videoUploadCancelledLessonKept: 'Загрузка ролика отменена, а урок удалить не удалось',
    reorderRefusedAi: 'Порядок не изменён: сейчас AI переписывает блоки',
    reorderBlocksFailed: 'Не удалось изменить порядок блоков',
    deleteLessonFailed: 'Не удалось удалить урок',
    createBlockFailed: 'Не удалось создать блок',
    duplicateBlockFailed: 'Не удалось скопировать блок',
    createLessonFailed: 'Не удалось создать урок',
    saveLessonFailed: 'Не удалось сохранить урок',
    reorderLessonsFailed: 'Не удалось изменить порядок уроков',
    typeLabelInfo: 'Изображение',
    typeLabelQuizMulti: 'Квиз (несколько)',
    typeLabelQuizSingle: 'Квиз (1 ответ)',
    typeLabelYesNo: 'Да / Нет',
    typeLabelFillBlank: 'Заполни пропуск',
    typeLabelMatch: 'Сопоставление',
    typeLabelArticle: 'Статья',
    typeLabelVideo: 'Видео',
    typeLabelDesign: 'Составной блок',
    typeLabelUnknown: 'Неизвестный',
    metaInfo: 'Картинка',
    metaInfoDesc: 'Картинка на весь экран',
    metaQuizMulti: 'Несколько ответов',
    metaQuizMultiDesc: 'Выбор нескольких ответов',
    metaQuizSingle: 'Один ответ',
    metaQuizSingleDesc: 'Выбор одного ответа',
    metaYesNo: 'Да / Нет',
    metaYesNoDesc: 'Вопрос Да или Нет',
    metaFillBlank: 'Заполни пропуск',
    metaFillBlankDesc: 'Заполнить пропущенное слово',
    metaMatch: 'Соответствие',
    metaMatchDesc: 'Соединить пары',
    metaVideo: 'Видео',
    metaVideoDesc: 'Видео 9:16 или 16:9',
    metaArticle: 'Статья',
    metaArticleDesc: 'Встроить инструкцию из библиотеки',
    metaDesign: 'Составной блок',
    metaDesignDesc: 'Текст, таблицы, картинки, бейджи',
    metaUnknown: 'Блок',
    drawStylePilot:
      'Стиль картинок курса ещё не задан — его определит выбор варианта из заказанного набора.',
    drawStyleMissing: 'Стиль картинок курса не задан — без него отрисовка не запустится.',
    drawQuoteFailed: 'Смета не загрузилась — размер плана и цена неизвестны, запуск погашен.',
    drawQuoteRefresh: 'Обновить смету',
    drawAwaitingAuthor: (jobId: number) =>
      `Запуск #${jobId} ждёт вашего ответа — ответьте на вопрос в чате, и запуск продолжится сам.`,
    drawCourseBusy: (jobId: number, jobType: string) =>
      `Курс занят запуском #${jobId} (${jobType}) — дождитесь его окончания.`,
    drawFrozen: 'Курс на проверке — отрисовка станет доступна после решения.',
    drawTitle: 'Нарисовать картинки',
    drawAutoDescription:
      'Нарисуются только пустые места исходного языка курса, у которых есть промпт. Уже нарисованное не перерисовывается.',
    drawManualDescription:
      'Выберите места и языковой слот. Уже нарисованное войдёт в план только с галочкой перерисовки.',
    drawSetStyle: 'Задать стиль картинок',
    drawStarting: 'Запускаю…',
    draw: 'Нарисовать',
  },
  en: {
    a11yBack: 'Back',
    a11yDelete: 'Delete',
    a11yDeleteBlock: 'Delete block',
    openBlockPanel: 'Block settings',
    closeBlockPanel: 'Close settings',
    hideAiPanel: 'Hide AI panel',
    showAiPanel: 'Show AI panel',
    noRights: 'No permission',
    saving: 'Saving…',
    save: 'Save',
    delete: 'Delete',
    cancel: 'Cancel',
    loadFailedTitle: 'Oops, couldn’t open the course',
    loadFailedDescription: 'Check your connection and try again.',
    retry: 'Retry',
    overflowWarnLabel: 'A lot of text',
    overflowWarnHint:
      'The block is a bit taller than the screen: on a phone it will shrink and the text will get smaller. We recommend shortening it so it reads well.',
    overflowLabel: 'Content doesn’t fit',
    overflowHint:
      'Content doesn’t fit: on a phone the text would get too small. Shorten the text or remove an element — otherwise the course can’t be published.',
    deleteScreenUnknown: 'Delete block?',
    deleteScreen: (n: number) => `Delete block ${n}?`,
    deleteScreenDescription: (label: string) =>
      `The “${label}” block will be deleted in all course languages. This can’t be undone.`,
    duplicateScreen: 'Duplicate block',
    editNotice: 'AI is rewriting this block. You can edit it once AI is done.',
    editHeaderTitle: 'AI is rewriting this block',
    editChip: 'Rewriting',
    editThumbTitle: 'AI is rewriting this block',
    translationNotice:
      'The course is being translated. This block can’t be edited until the translation finishes.',
    translationHeaderTitle: 'Translating — block can’t be edited',
    translationChip: 'Translating',
    translationThumbTitle: 'Course is being translated',
    reviewNotice: 'The course is under review. You can edit once a decision is made.',
    reviewHeaderTitle: 'Course under review — block can’t be edited',
    reviewChip: 'Under review',
    reviewThumbTitle: 'Under review',
    selectBlockOrLesson: 'Select a block or lesson',
    courseSettings: 'Course settings',
    courseNotFound: 'Course not found',
    selectArticle: 'Select an article',
    reviewLockWithdraw:
      'The course is under review — editing will be back once a decision is made. You can withdraw the request in the publish dialog.',
    reviewLock: 'The course is under review — editing will be back once a decision is made.',
    selectBlockForPreview: 'Select a block to preview',
    addLessonFirst: 'Add a lesson and a block below first',
    addLesson: 'Add lesson',
    collapseScreens: 'Collapse blocks',
    expandScreens: 'Show block thumbnails',
    untitled: 'Untitled',
    deleteLesson: (n: number) => `Delete lesson ${n}?`,
    deleteLessonButton: 'Delete lesson',
    deleteLessonDescription:
      'The lesson and all its blocks will be deleted in all course languages. This can’t be undone.',
    lessonImage: 'Lesson image',
    upload: 'Upload',
    tabInfo: 'Info',
    tabLook: 'Design',
    lessonNumber: (n: number) => `Lesson ${n}`,
    lessonSettings: 'Lesson settings',
    translationTextLocked: 'Translating — text can’t be edited for now',
    lessonName: 'Lesson title',
    shortDescription: 'Short description',
    shortDescriptionPlaceholder: 'One sentence about this lesson',
    noPattern: 'No pattern',
    blocksBackground: 'Block background',
    lessonTheme: 'Lesson theme',
    pattern: 'Pattern',
    backgroundPattern: 'Background pattern',
    desktop: 'Desktop',
    phone: 'Phone',
    rotatePhone: 'Rotate phone',
    lookRefusedReview: 'Design not applied: the course is under review',
    lookRefusedAi: 'Design not applied: AI is rewriting blocks right now',
    lookPartial: 'Design wasn’t applied to every block — try again',
    saveBlockFailed: 'Couldn’t save the block',
    designTextTooLong:
      `The text is over ${DESIGN_TEXT_STUDIO_LIMIT} characters — shorten it, or the block won’t be saved`,
    deleteBlockFailed: 'Couldn’t delete the block',
    videoUploadCancelledBlockKept: 'The video upload was cancelled, but the block could not be deleted',
    videoUploadCancelledLessonKept: 'The video upload was cancelled, but the lesson could not be deleted',
    reorderRefusedAi: 'Order not changed: AI is rewriting blocks right now',
    reorderBlocksFailed: 'Couldn’t reorder blocks',
    deleteLessonFailed: 'Couldn’t delete the lesson',
    createBlockFailed: 'Couldn’t create the block',
    duplicateBlockFailed: 'Couldn’t duplicate the block',
    createLessonFailed: 'Couldn’t create the lesson',
    saveLessonFailed: 'Couldn’t save the lesson',
    reorderLessonsFailed: 'Couldn’t reorder lessons',
    typeLabelInfo: 'Image',
    typeLabelQuizMulti: 'Quiz (multiple answers)',
    typeLabelQuizSingle: 'Quiz (single answer)',
    typeLabelYesNo: 'Yes / No',
    typeLabelFillBlank: 'Fill in the blank',
    typeLabelMatch: 'Matching',
    typeLabelArticle: 'Article',
    typeLabelVideo: 'Video',
    typeLabelDesign: 'Composite block',
    typeLabelUnknown: 'Unknown',
    metaInfo: 'Image',
    metaInfoDesc: 'Full-screen image',
    metaQuizMulti: 'Multiple answers',
    metaQuizMultiDesc: 'Pick several answers',
    metaQuizSingle: 'Single answer',
    metaQuizSingleDesc: 'Pick one answer',
    metaYesNo: 'Yes / No',
    metaYesNoDesc: 'Yes-or-no question',
    metaFillBlank: 'Fill in the blank',
    metaFillBlankDesc: 'Fill in the missing word',
    metaMatch: 'Matching',
    metaMatchDesc: 'Connect pairs',
    metaVideo: 'Video',
    metaVideoDesc: 'Video 9:16 or 16:9',
    metaArticle: 'Article',
    metaArticleDesc: 'Embed an article from the library',
    metaDesign: 'Composite block',
    metaDesignDesc: 'Text, tables, images, badges',
    metaUnknown: 'Block',
    drawStylePilot:
      'The course image style isn’t set yet — it will be set by the variant you pick from the batch you order.',
    drawStyleMissing: 'The course image style isn’t set — image generation can’t start without it.',
    drawQuoteFailed:
      'The estimate didn’t load — plan size and price are unknown, so starting is disabled.',
    drawQuoteRefresh: 'Refresh estimate',
    drawAwaitingAuthor: (jobId: number) =>
      `Run #${jobId} is waiting for your answer — reply to the question in the chat and it will continue on its own.`,
    drawCourseBusy: (jobId: number, jobType: string) =>
      `The course is busy with run #${jobId} (${jobType}) — wait for it to finish.`,
    drawFrozen:
      'The course is under review — image generation will be available once a decision is made.',
    drawTitle: 'Generate images',
    drawAutoDescription:
      'Images will be generated only for empty spots in the course’s source language that have a prompt. Existing images won’t be regenerated.',
    drawManualDescription:
      'Pick spots and a language slot. Existing images are included only if you tick “Regenerate existing images”.',
    drawSetStyle: 'Set image style',
    drawStarting: 'Starting…',
    draw: 'Generate',
  },
})
